<div class="main-content1">
<div class="maintenance-wrapper">
  <div class="illustration-container">
    <img src="/assets/maintenance-illustration.png" alt="Under Maintenance" />
  </div>
<div class="content">
  <h2 class="title">Thank you for your interest.</h2>

  <p class="subtitle">
   Our team is actively working to make this section available as soon as possible
  </p>

  <button class="back-btn" routerLink="/">
    Back to Home
  </button>
  </div>
</div>
</div>
